/**
 * PrimeVue Theme Configuration
 * Custom theme configuration for MySettle
 */
import Aura from '@primevue/themes/aura'

export const primeVueConfig = {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: false,
      cssLayer: false,
      // Customize theme colors
      prefix: 'p',
      // Component-specific overrides can be added here
      // For example:
      // primaryColor: '#6366f1', // indigo-500
      // borderRadius: '0.5rem',
    },
  },
  // Ripple effect (can be disabled for better performance)
  ripple: true,
  // Input style (outlined, filled)
  inputStyle: 'outlined',
  // Z-index configuration
  zIndex: {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
  },
}

